import React from 'react'
import { Form } from 'react-bootstrap'
import ModalCustom from '../../UI/modal'
import ThInputText from '../../forms/th-input-text'
import Button from '../../UI/button'
import ChangeImage from '../../UI/change-image'

type PublishTripModalProps = {
	show: boolean,
	handleClose: () => void
}

const PublishTripModal = ({
	show,
	handleClose
}: PublishTripModalProps) => {
	const [tripName, setTripName] = React.useState('')
	const [tripDescription, setTripDescription] = React.useState('')

  return (
	<ModalCustom show={show} onHide={handleClose} title='Publish the Trip'>
		<Form>
			<ThInputText
				label='Title'
				placeholder='Enter here'
				value={tripName}
				onChange={(value) => setTripName(value)}
				required
			/>
			<ThInputText
				label='Location (city, country)'
				placeholder='Enter here'
				value={tripDescription}
				onChange={(value) => setTripDescription(value)}
				mb={24}
			/>
			<Form.Group>
				<Form.Label>Description</Form.Label>
				<Form.Control as='textarea' rows={3} placeholder='Enter here' />
			</Form.Group>
			<ThInputText
				label='Categories'
				placeholder='+Add '
				value={tripDescription}
				onChange={(value) => setTripDescription(value)}
				mb={24}
				mt={24}
			/>
			<ChangeImage style={{marginBottom: '24px'}}/>
			<div className='d-flex justify-content-between align-items-center'>
				<Button px={50} variant='outline-primary' type='button'>Cancel</Button>
				<Button px={50} disabled={!tripName && !tripDescription} variant='dark' type='submit'>Publish</Button>
			</div>
		</Form>
	</ModalCustom>
  )
}
export default PublishTripModal